var CustomCheckbox = {	

	init:function(){
		
		Debug.log("CUSTOM CHECKLBOX INIT");
		
		$(".custom-checkbox").on("click touchend", function(e){
			e.stopImmediatePropagation();
			if(e.type == "touchend"){
				$(this).off("click");
			}
			if($(this).find("input[type='checkbox']").is(':checked')){
				$(this).addClass("selected");
			}else{
				$(this).removeClass("selected");
			}
		});

		$(".custom-radio").on("click touchend", function(e){
			e.stopImmediatePropagation();
			if(e.type == "touchend"){
				$(this).off("click");
			}
			var _name_radio = $(this).find("input[type='radio']").attr("name");
			
			$("input[name='"+ _name_radio+"'").each(function(i){				
				if($(this).is(':checked')){
					$(this).parent().addClass("selected");
				}else{
					$(this).parent().removeClass("selected");
				}
			});
		});
	}
}

$(window).load(function(){
	if($('.custom-checkbox, .custom-radio').length){
		CustomCheckbox.init();
	}
})